<div
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragHandle
  class="bg_{{ themeType }} grabbable"
>
  <h6>{{ display.cache.title }}</h6>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
  >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <p>{{ display.cache.message }}</p>
</div>

<div
  mat-dialog-actions
  class="border_shadow_top_inset"
>
  <button
    mat-raised-button
    mat-dialog-close
    type="button"
  >{{ display.cache.cancel }}</button>

  <button
    (click)="confirm()"
    mat-raised-button
    class="bg_{{ themeType }}"
    type="button"
  >{{ display.cache.confirm }}</button>
</div>
